import {
    ListBase,
    useGetIdentity,
    useListContext,
    Title,
} from 'react-admin';
import {
    Box,
    Stack,
    CircularProgress,
} from '@mui/material';
import { InsightsOverview } from './InsightsOverview';

export const InsightsList = () => {
    const { identity } = useGetIdentity();
    if (!identity) return null;

    return (
        <ListBase perPage={100} sort={{ field: 'date', order: 'DESC' }}>
            <InsightsListLayout />
        </ListBase>
    );
};

const InsightsListLayout = () => {
    const { isLoading } = useListContext();

    if (isLoading) {
        return (
            <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Stack spacing={2} mt={2}>
            <Title title="Insights" />
            <InsightsOverview />
            <Box sx={{ height: 16 }} />
        </Stack>
    );
};
